import { c as _c } from "react/compiler-runtime";
import { CookieConsent } from "@repo/ui/components/ui/cookie-consent";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { LoginModal } from "@/lib/components/auth/LoginModal";
import { AppNav } from "@/lib/components/common/AppNav";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Route = createFileRoute("/_app")({
  component: AppLayout
});
function AppLayout() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(AppNav, {});
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsxs("div", {
      className: "flex min-h-dvh flex-col",
      children: [t0, /*#__PURE__*/_jsx("main", {
        className: "flex-1",
        children: /*#__PURE__*/_jsx(Outlet, {})
      }), /*#__PURE__*/_jsx(LoginModal, {}), /*#__PURE__*/_jsx(CookieConsent, {
        variant: "mini",
        learnMoreHref: "/om/integritet",
        description: "Vi anv\xE4nder cookies f\xF6r att s\xE4kerst\xE4lla att du f\xE5r den b\xE4sta upplevelsen p\xE5 v\xE5r webbplats."
      })]
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}